import imageCompression from 'browser-image-compression';

/**
 * Compresses an image file to max 200KB / 800px.
 * Backend hard limit is 300KB — this leaves a safety margin.
 */
export async function compressImage(file: File): Promise<File> {
  const options = {
    maxSizeMB: 0.2,
    maxWidthOrHeight: 800,
    useWebWorker: true,
    fileType: 'image/jpeg' as const,
  };
  return await imageCompression(file, options);
}

/**
 * Converts a File to a base64-encoded string (without the data URI prefix).
 */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
